import { ISetting } from '@/types'
import { getAppHost } from '@/utils/getAppHost'

// Dynamic host detection - no hardcoded URLs needed
const HOST = getAppHost()

export const baseSettings: Partial<ISetting> = {
  app: {
    code: 'cdoplus',
    title: 'CDO',
    description: 'Enjoy CDO Live in all your screens. Watch live matches, highlights, and more.',
    defaultLanguage: 'es',
  },
  fonts: {
    base: 'gilroy',
    display: 'gilroy',
  },
  images: {
    ogImage: 'https://www.fanatiz.com/fanatiz/web/other/og-image-CDO.png',
    qrCode: '/assets/images/cdo/qr.svg',
    lottie: '/assets/lotties/clients/cdo/main/loading.json',
    favicons: {
      icon: '/assets/images/cdo/favicons/favicon.ico',
      svg: '/assets/images/cdo/favicons/icon.svg',
      apple: '/assets/images/cdo/favicons/apple-touch-icon.png',
    },
  },
  gtm: {
    id: 'GTM-MG5F5KDC',
    secondaryId: 'GTM-NPMDG4S',
    gateway: {
      enabled: true,
    },
  },
  cmp: {
    id: 'f74ecac54210d',
  },
  youbora: {
    accountCode: 'fanatiz',
    active: false,
  },
  intercom: {
    enabled: false,
  },
  wsc: {
    key: '702ed17a0eff4ccda76e7772c840bfe4'
  },
  optimizely: {
    sdkKey: 'TGhTYhnEYoEbUxpW9qp5h',
    isActive: false,
  },
}

export const envOverrides: Record<string, Partial<ISetting>> = {
  development: {
    app: {
      title: 'CDO Plus - Development',
      description: 'CDO Plus - Development',
    },
    api: {
      host: HOST,
      cinematicsTag: 'cdoProd',
    },
    optimizely: {
      sdkKey: 'Vxw39YYYPdX1wkZauXMQ7',
      isActive: false,
    },
  },
  staging: {
    api: {
      host: HOST,
      cinematicsTag: 'cdoProd',
    },
  },
  production: {
    api: {
      host: HOST,
      cinematicsTag: 'cdoProd',
    },
    youbora: {
      accountCode: 'fanatiz',
      active: true,
    },
  },
}